import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import store from '../common/provider/store.provider'
// import IndexPage from '@/pages/index/index'
import SpeakersPage from '@/pages/speakers/speakers'
import MediasPage from '@/pages/medias/medias'
import AgendaPage from '@/pages/agenda/agenda'
import VideoPage from '@/pages/video/video'
import LoginPage from '@/pages/login/login'
import InforPage from '@/pages/infor/infor'
import RoomPage from '@/pages/rooms/rooms'
import SearchtPage from '@/pages/search/search'
import ClassPage from '@/pages/class/class'
import ZoomPage from '@/pages/zoom/zoom'
import ReplayPage from '@/pages/index/indexReplay'

Vue.use(Router)
Vue.use(Meta)

const FrameRouter = {}
FrameRouter.routers = [
  {
    path: '/replay',
    name: 'ReplayPage',
    component: ReplayPage
  },
  {
    path: '/',
    name: 'IndexPage',
    component: ReplayPage
  },
  {
    path: '/speakers',
    name: 'SpeakersPage',
    component: SpeakersPage
  },
  {
    path: '/medias',
    name: 'MediasPage',
    component: MediasPage
  },
  {
    path: '/agenda',
    name: 'AgendaPage',
    component: AgendaPage
  },
  {
    path: '/video',
    name: 'VideoPage',
    component: VideoPage
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/infor',
    name: 'InforPage',
    component: InforPage,
    meta: {
      auth: true
    }
  },
  {
    path: '/rooms',
    name: 'RoomPage',
    component: RoomPage
  },
  {
    path: '/search',
    name: 'SearchtPage',
    component: SearchtPage
  },
  {
    path: '/class',
    name: 'ClassPage',
    component: ClassPage
  },
  {
    path: '/zoom',
    name: 'ZoomPage',
    component: ZoomPage
  }
]

const appRouter = new Router({
  // mode: 'history',
  routes: FrameRouter.routers,
  savaScrollPosition: false,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

appRouter.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    store.commit('userLogout')
  }
  let token = store.state.login.token
  console.log('token:' + token)
  if (to.meta.auth) {
    if (token) {
      next()
    } else {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    }
  } else {
    next()
  }
  // document.title = to.meta.title
})

export default appRouter



// WEBPACK FOOTER //
// ./src/router/index.js